// Exception acceptance and approval on the Portal side (Stage 3a slice 8, plan §D2-D3): the
// submit key that keeps one commandId per user action, the "nei tempi / in ritardo" of the
// approval dialog, and the dialog error of a failed write. Plain module with no Vue, so it runs
// under `node --test`. The API checks the role and the rules; these helpers only shape the UI.
import { formatCivilDate } from "../Acceptance/deadlines.mjs";

// The key of one decision: a retry of the same decision reuses its commandId (P5).
// kind is "accept" ({ checklistId, resultId, note }) or "approve" ({ checklistId }).
export function decisionKey(kind, { checklistId, resultId, note } = {}) {
  if (kind === "accept") {
    return ["accept", checklistId, resultId, String(note || "").trim()].join(
      "|",
    );
  }
  return ["approve", checklistId].join("|");
}

// { timing, dueDate } for the approval confirm dialog: "late" while the view is overdue (today in
// Rome after the due date), otherwise "on_time" (also without a due date, never late without one).
// The API decides with its own clock and stores the result.
export function approvalTiming(view) {
  const deadline = (view && view.deadline) || {};
  return {
    timing: deadline.status === "overdue" ? "late" : "on_time",
    dueDate: formatCivilDate(deadline.dueDate),
  };
}

// The i18n key of a failed acceptance or approval shown in the dialog. A 409 never gets here: the
// page shows the conflict banner with "Ricarica" instead.
export function decisionError(err) {
  const res = err && err.response;
  const data = (res && res.data) || {};
  if (res && res.status === 403) return "workshop.decision_errors.not_manager";
  if (data.code === "approval_blocked") {
    return "workshop.decision_errors.approval_blocked";
  }
  if (data.code === "not_an_exception") {
    return "workshop.decision_errors.not_an_exception";
  }
  if (
    data.code === "invalid_input" &&
    data.details &&
    data.details.field === "note"
  ) {
    return "workshop.decision_errors.note_too_long";
  }
  return "workshop.decision_errors.generic";
}
